import React, { Component } from 'react';
import { connect } from 'react-redux';
import isEqual from 'lodash.isequal';

import ActivityCard from '../../Card/ActivityCard';
import Pagination from '../../Pagination/index';
import {searchActivities} from "../../../actions/findActivities/search/get";

class ActivityList extends Component
{
    state = {
        page : this.props.listCurrentPage || 1,
        results: this.props.results,
    };

    componentDidMount() {
        this.update();
        this.setState({ results: this.props.results });
    }

    componentWillReceiveProps(nextProps) {
        if (!isEqual(this.props.results, nextProps.results)) {
            this.setState({ results: nextProps.results });
        }
        if (!isEqual(this.state.page, nextProps.listCurrentPage)) {
            this.setState({ page: nextProps.listCurrentPage });   
        }
    }

    update() {
        this.props.setListCurrentPage(this.state.page);
        this.props.searchActivities(this.props.searchValues, this.props.selectedFilters, this.state.page);
    }

    render() {
        const { data, total, last_page } = this.state.results;       
        const list = [];

        if (data && total > 0) {
            list.push(<div className="five-cols activity-list" key={0}>
                {
                    Object.keys(data).map((item) => (
                        (data[item].organisation ? 
                        <div key={data[item].id} className="col">
                            <ActivityCard
                                item={data[item]}
                            />
                        </div> : null )
                    ))
                }
            </div>);

            if (last_page > 1) {
                list.push(<Pagination key={1}
                                      total={total}
                                      currentPage={this.state.page}
                                      lastPage={last_page}
                                      changePage={page => this.setState({ page }, () => { this.update(); })}
                />);
            }
        }

        return  (list);
    }
}

const mapStateToProps = (state) => ({
    results: state.searchActivities ? state.searchActivities : {},
    searchValues: state.searchValues ? state.searchValues : {},
    selectedFilters: state.selectedFilters ? state.selectedFilters : {},
});

const mapDispatchToProps = dispatch => ({
    searchActivities: (values, filters, page) => {
        dispatch(searchActivities(values, filters, false, page, 'list'));
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(ActivityList);

